// extracted by mini-css-extract-plugin
export default {"applePayButton":"applePayButton___heM3_"};